import { objectSpread2 as _objectSpread2, defineProperty as _defineProperty } from '../_virtual/_rollupPluginBabelHelpers.js';

var generateSkeletonData = function generateSkeletonData(keys) {
  var rows = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
  return Array.from(Array(rows).keys()).map(function (_, idx) {
    return keys.reduce(function (acc, cur, keyIdx) {
      return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, "".concat(cur), '~'), keyIdx + 1 === keys.length ? {
        key: idx
      } : {});
    }, {});
  });
};

export default generateSkeletonData;
//# sourceMappingURL=generate-skeleton-data.esm.js.map
